<mat-card *ngIf="loading">
  <mat-card-header>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <ngx-skeleton-loader count="1" appearance="line" animation="progress" [theme]="{
     'background-color': '#e7e7e7',
      height: '40px',
     'border-radius': 0
    }"></ngx-skeleton-loader>
  </mat-card-header>
  <mat-card-content>
    <ngx-skeleton-loader count="5" appearance="line" animation="progress" [theme]="{
      'background-color': '#e7e7e7',
        height: '50px',
      'border-radius': 0
        }">
    </ngx-skeleton-loader>
  </mat-card-content>
</mat-card>

<mat-card class="cardWithShadow" *ngIf="!loading">

  <mat-card-header>
    <mat-card-title-group class="col-9">
      <mat-card-title>Picchi rilevati</mat-card-title>
      <mat-card-subtitle>Andamento giornaliero</mat-card-subtitle>
    </mat-card-title-group>
    <div class="col-3 text-right" *ngIf="selectedSite !== 0">
      <!-- Header destro -->
      <h4 class="d-inline-block">{{selectedSiteName}}</h4>

      <button mat-raised-button color="primary" class="d-inline-block" (click)="getData(selectedSite)"
        style="margin: 15px;">
        <div class="d-inline-flex" style="position: relative;top: -10px;">
          <i-tabler name="refresh" class="icon-20 text-white"></i-tabler>
        </div>
      </button>
    </div>
  </mat-card-header>

  <mat-card-content>
    <div class="mt-5" *ngIf="!wrongFilters; else noDataBlock">
      <apx-chart #peaksChart
        *ngIf="chartOptions.series !== undefined && chartOptions.chart && selectedSite !== 0; else bloccoElse"
        [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
        [yaxis]="chartOptions.yaxis" [stroke]="chartOptions.stroke" [tooltip]="chartOptions.tooltip"
        [dataLabels]="chartOptions.dataLabels" [legend]="chartOptions.legend" [colors]="chartOptions.colors"
        [markers]="chartOptions.markers" [fill]="chartOptions.fill" [grid]="chartOptions.grid"
        [title]="chartOptions.title"></apx-chart>

      <ng-template #bloccoElse>
        <h3 class="text-center">Selezionare un sito e l'intervallo di 24 ore</h3>
      </ng-template>
    </div>
    <ng-template #noDataBlock>
      <h3 class="text-center">
        Parametri di ricerca errati. Nessun dato.
      </h3>
    </ng-template>

  </mat-card-content>

</mat-card>